<template>
  <div class="content-container flex-column">
    <TheLoader :active="loading"/>

    <div v-if="!loading" class="content-container flex-row">
      <section class="content large-padding small scrollnav">
        <form @submit.prevent="handleSubmit">
          <fieldset>
            <div class="grid-x card-grid grid-padding-x">
              <TheDateInput containerClassName="cell medium-4 large-3" label="Velg dato:"
                            name="Starttid" v-model.trim="Start" v-validate="'required'"/>
              <TheSelectInput
                containerClassName="cell medium-3 large-2"
                label="Sorter:"
                name="asc_desc"
                v-model.trim="objectFilters.sort_by"
                :items="sorterOptions"
              />
              <TheSelectInput
                containerClassName="cell medium-3 large-2"
                label="Limit"
                name="limit"
                v-model.trim="objectFilters.limit"
                :items="limitOptions"
              />
              <div class="cell medium-2 large-5" style="text-align: right;">
                <label>&nbsp;</label>
                <a href="javascript:;" @click="getElasticObjects()" class="button primary">Oppdater</a>
              </div>
              <div class="cell medium-2 large-5" style="text-align: left;">
                <label>&nbsp;</label>
                <a href="javascript:;" @click="getElasticObjects(true)" :class="objectFilters.viewed ? 'button primary' : 'button secondary'">{{objectFilters.viewed ? 'Vis utstilte objekter' : 'Skjul utstillte objekter'}}</a>
              </div>
            </div>
            <div class="grid-x card-grid grid-padding-x">
              <div class="cell medium-12 large-12">
                <div class="grid-x card-grid grid-padding-x">
                  <div class="cell medium-12 large-12" v-if="objectList.length > 0">
                      <article class="episode" v-for="(object) in objectList" :key="object.name" :v-if="true">
                        <div class="episode__number">
                          <div v-if="object.photos_fotoware.large">
                            <img :src="object.photos_fotoware.large[0]"/>
                          </div>
                        </div>
                        <div class="episode__content">
                          <div class="story">
                            <p style="margin: 2px;">Objektnummer {{object.Kontraktnr}} - {{object.Lopenr}} / Utstillt: {{object.lokasjon.Beskrivelse}}</p>
                            <div v-if="object.Kunstner">
                              <p style="margin: 2px; font-size: 24px;">{{object.Kunstner}}</p>
                              <p style="margin-top: 2px; font-size: 18px; color: #4a4a4a; margin-bottom: 10px;">{{object.Katalogtekst1}}</p>
                            </div>
                            <div v-else>
                              <p style="margin: 2px; font-size: 24px;">{{object.Katalogtekst1}}</p>
                            </div>
                            <p style="margin: 2px;">{{object.Objekt3}}</p>
                            <p style="margin: 2px;">{{object.Katalogtekst2}}</p>
                            <p style="margin: 2px;">
                              <span v-if="object.Antall">ANTALL {{object.Antall}} /</span>
                              <span v-if="object.Hoyde">HØYDE {{object.Hoyde}} /</span>
                              <span v-if="object.Lengde">LENGDE {{object.Lengde}} /</span>
                              <span v-if="object.Dybde">DYBDE {{object.Dybde}} /</span>
                              <span v-if="object.Diameter">DIAMETER {{object.Diameter}} </span>
                            </p>
                            <p style="margin: 2px;" v-if="object.NettMerknad"><strong>Merknad:</strong> {{object.NettMerknad}}</p>
                          </div>
                          <div class="cta">
                            <a href="javascript:;" @click="toggleView(object.Objektid)" :class="object.hide_ready_for_auction ? 'button primary' : 'button secondary'">{{object.hide_ready_for_auction ? 'Merk som IKKE utstillt' : 'Merk som utstilt'}}</a>
                          </div>
                        </div>
                      </article>
                    <div class="pagination-container" v-if="pageCount > 1" style="margin-top: 3rem;">
                      <paginate v-model="currentPage"
                                :page-count="pageCount"
                                :page-range="11"
                                :click-handler="changePage"
                                :container-class="'pagination'"
                                :prev-text="paginationArrow"
                                :next-text="paginationArrow"
                                :prev-class="'prev'"
                                :next-class="'next'"
                      >
                      </paginate>
                    </div>
                  </div>
                  <div v-else>
                    <p>Ingen gjenstander funnet</p>
                  </div>
                </div>
              </div>
            </div>
          </fieldset>
        </form>
      </section>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import NettAuksjonService from '@/services/NettAuksjonService'
import ReportViewService from '@/services/ReportViewService'

let start = moment()

export default {
  name: 'GjenstanderKlareForAuksjon',
  $_veeValidate: {
    validator: 'new'
  },
  data () {
    return this.initialState()
  },
  created () {
    this.getElasticObjects()
  },
  methods: {
    initialState () {
      return {
        Start: start.format('YYYY-MM-DD'),
        objectList: [],
        currentPage: 1,
        pageCount: 1,
        sorterOptions: [
          {key: 'Start', val: 'Start'},
          {key: 'Slutt', val: 'Slutt'},
          {key: 'Kategori', val: 'Kategori'},
          {key: 'Kontraktnr', val: 'Kontraktnr'}
        ],
        objectFilters: {
          page: 1,
          limit: 10,
          exclude: [],
          sort_by: 'Start',
          asc_desc: 'DESC',
          viewed: (JSON.parse(localStorage.report_objects_ready_for_auction_viewed || false) === true) || false
        },
        limitOptions: [
          {key: 10, val: 'Vis 10 pr.side'},
          {key: 100, val: 'Vis 100 pr.side'},
          {key: 250, val: 'Vis 250 pr.side'},
          {key: 500, val: 'Vis 500 pr.side'},
          {key: 1000, val: 'Vis 1000 pr.side'}
        ],
        loading: true
      }
    },
    getElasticObjects: function (toggle = false) {
      this.loading = true

      if (toggle) {
        localStorage.report_objects_ready_for_auction_viewed = !this.objectFilters.viewed
        this.objectFilters.viewed = !this.objectFilters.viewed
      }

      NettAuksjonService.getElasticSearchObjects(this.Start, this.objectFilters).then((response) => {
        this.objectList = response.data.data
        this.pageCount = response.data.paginate ? (response.data.paginate.pageCount || 1) : 1
        this.loading = false
      }).catch((error) => {
        this.$helpers.sendApiErrorsToValidator(error, this.errors)
        if (this.errors.any()) {
          this.$validator.resume()
          this.$helpers.showErrorAlert('Kunne ikke hente auksjoner')
          this.loading = false
        }
      })
    },
    toggleView: function (objectId) {
      var vm = this
      vm.loading = true
      ReportViewService.toggleView(objectId, 'report_ready_for_auction').then(() => {
        vm.getElasticObjects()
      }).catch((error) => {
        vm.$helpers.sendApiErrorsToValidator(error, vm.errors)
        if (vm.errors.any()) {
          vm.$validator.resume()
          vm.$helpers.showErrorAlert('Kunne ikke hente auksjoner')
          vm.loading = false
        }
      })
    },
    changePage: function (page) {
      var vm = this
      window.jQuery('html, body').animate({
        scrollTop: 0
      }, 200, function () {
        vm.objectFilters.page = page
        vm.getElasticObjects()
      })
    }
  }
}
</script>
<style>
  .episode {
    border: 2px solid gray;
    display: grid;
    margin: 10px;
    grid-template-columns: 1fr 3fr;
    position: relative;
  }

  .episode__number {
    font-size: 10vw;
    font-weight: 600;
    padding: 10px;
    position: sticky;
    top: 0;
    text-align: center;
    height: 100%;
    transition: all 0.2s ease-in;
  }

  .episode__content {
    grid-template-columns: 1fr 4fr;
    grid-gap: 10px;
    padding: 15px 30px;
  }

  .episode__content .story {
    line-height: 26px;
  }

  .episode__content .cta {
    padding-top: 30px;
  }

  @media (max-width: 600px) {
    .episode__content {
      grid-template-columns: 1fr;
    }
  }

  @media (max-width: 576px) {
    .episode__content .story {
      font-size: 15px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Admin/Reports/GjenstanderKlareForAuksjon.vue